import { Flex, Text } from '@bitrise/bitkit';
import React, { ReactNode, FunctionComponent } from 'react';

interface Props {
  children: ReactNode;
}

const ComingSoon: FunctionComponent<Props> = (props) => {
  const { children, ...rest } = props;

  return (
    <Flex {...rest} maxWidth="38.375rem">
      <Text align="middle" config="3" margin="x10">
        Feature coming soon! 🚀
      </Text>

      <Flex margin="x10">{children}</Flex>
    </Flex>
  );
};

export default ComingSoon;
